import {
  resolveBackendConfig,
  resolveApiBaseUrl,
} from '../../../../shared/backend/config';

export { resolveApiBaseUrl, resolveBackendConfig };

export const backendConfig = resolveBackendConfig(import.meta.env);
